module.exports = __webpack_public_path__ + "static/media/sticker.2751fbf0.png";